window.dtScheduleAssignment = function () {
  const dt_schedule_assignment = new DataTable('#schedule-assignment-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#schedule-assignment-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#schedule-assignment-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "note" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}